import React, {useState, useRef} from "react";
import styles from "./ContactForm.scss";
import classnames from "classnames";
import PropTypes from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import Input from "components/shared/elements/Input";
import Button from "components/shared/elements/Button";
import Loader from "components/shared/elements/Loader";
import {isValidEmailAddress} from "utils/text_helpers";
import { sendContactForm, validateRecaptcha } from "api/SiteApi";

const RECAPTCHA_SITE_KEY = window.ENV.RECAPTCHA_SITE_KEY;
export default function ContactForm(props) {

    const [formData, setFormData]  = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        question: "",
    });
    const [ticketLink, setTicketLink] = useState(null);
    const [formSent, setFormSent] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [recaptchaError, setRecaptchaError] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [validating, setValidating] = useState(false);

    const recaptchaRef = useRef();

    const updateForm = ({name, value}) => {
        setFormData({
            ...formData,
            [name]: value,
        })
    }

    const isValid = async () => {
        const validEmail = isValidEmailAddress(formData.email);
        const hasName = !!formData.firstName && !!formData.lastName;
        setNameError(!hasName);
        setEmailError(!validEmail);

        const token = await recaptchaRef.current.executeAsync();
        const recaptchaPass = await validateRecaptcha(token)
            .then((res) => {
                const recaptchaSuccess = res.body.success;
                if(!recaptchaSuccess) {
                    alert("Google says you're a ROBOT!!!\n\nIf you are... that's pretty cool that a Robot wants to play some Jazz.\n\nIf you're not a robot, hit 'OK' and try again.");
                    // toaster.error("Google says you're a ROBOT!!!");
                }
                return recaptchaSuccess;

            })
            .catch((err) => {
                return false;
            });

        setRecaptchaError(!recaptchaPass);
        return hasName && validEmail && recaptchaPass;
    }

    const submitForm = async () => {
        setValidating(true);
        const validated = await isValid();
        if(validated) {
            sendContactForm(formData)
                .then((res) => {
                    const responseData = JSON.parse(res.body);
                    if(props.onMessageSent) {
                        props.onMessageSent(responseData);
                    }
                    setTicketLink(responseData.link);
                    setFormSent(true);
                })
                .catch((err) => {
                    console.error(err);
                });
        }
        setValidating(false);
    }

    // TODO: Display link to Jira or other Service?
    // const getLinkText = () => {
    //     if (!ticketLink) return '';
    //     return (
    //         <span>You can check the status of your request <a href={ticketLink} target="_blank" title="Contact Link">here</a></span>
    //     );
    // }

    if(formSent) {
        return (
            <div className={classnames(styles.root, {
                [styles.formSent]: formSent,
            })}>
                <h3>Thank you for contacting us, we'll get back to you as soon as possible.</h3>
                <a className={"btn btn-primary"} href={"/"} title="Return to home page">Back to JazzWire</a>
            </div>
        )
    }

    return (
        <div className={styles.root}>
            <div className={"flex align-end margin-bottom-lg"}>
                <div className={"flex-1 margin-lr-05"}>
                    <Input
                        name={"firstName"}
                        type={"text"}
                        placeholder={"First"}
                        onChange={updateForm}
                        label={"Name"}
                        value={formData.firstName}
                        required
                        inError={nameError}
                    />
                </div>
                <div className={"flex-1 margin-lr-05"}>
                    <Input
                        name={"lastName"}
                        type={"text"}
                        placeholder={"Last"}
                        onChange={updateForm}
                        value={formData.lastName}
                        inError={nameError}
                    />
                </div>
            </div>
            <div className={"flex align-end margin-bottom-lg"}>
                <div className={"flex-1 margin-lr-05"}>
                    <Input
                        name={"email"}
                        type={"email"}
                        onChange={updateForm}
                        label={"Email"}
                        value={formData.email}
                        required
                        inError={emailError}
                    />
                </div>
                <div className={"flex-1 margin-lr-05"}>
                    <Input
                        name={"phone"}
                        type={"tel"}
                        onChange={updateForm}
                        label={"Phone"}
                        value={formData.phone}
                    />
                </div>
            </div>
            <div className={"flex align-end margin-bottom-lg"}>
                <div className={"flex-1 margin-lr-05"}>
                    <Input
                        name={"question"}
                        type="textarea"
                        onChange={updateForm}
                        label={"What is your question?"}
                        minLines={5}
                        value={formData.question}
                    />
                </div>
            </div>
            {/* TODO: ADD RECAPTCHA */}
            <div>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={RECAPTCHA_SITE_KEY}
                />
                <div className={styles.disclaimer}><span>*</span> denotes a required field</div>
            </div>
            <div className={"flex"}>
                <Button onClick={submitForm} buttonText={"Submit"} disabled={validating} />
            </div>
            {validating && (
                <div className={styles.loader}>
                    <Loader dark />
                </div>
            )}
        </div>
    );
}

ContactForm.propTypes = {
    onMessageSent: PropTypes.func,
}
